//Window Resize
function windowIsSmallerThan(width = 0,callbackToRun) {
    width > 0 && callbackToRun()
    return window.innerWidth < width
}

//Window resized
class ResizeHandler {
    constructor() {
        this.functions = [];
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
    }

    addFunction(fn) {
        if (typeof fn === 'function') {
            this.functions.push(fn);
        } else {
            console.error('Argument must be a function');
        }
    }

    handleResize() {
        this.functions.forEach(fn => fn());
    }
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

// Delete a cookie (set expiry in the past)
function deleteCookie(name) {
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
}

//Exports
export {windowIsSmallerThan, ResizeHandler, setCookie, getCookie, deleteCookie}  